import { Button, Checkbox, Modal, PageHeader, message } from 'antd';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import phone from '../../../../assets/images/phone.svg';
import mail from '../../../../assets/images/mail.svg';
import pin from '../../../../assets/images/Pin.svg';
import empCard from '../../../../assets/images/emp_card.svg';
import calender from '../../../../assets/images/calender.svg';
import DP from '../../../../assets/images/dp_img.png';
import back from '../../../../assets/images/back_arrow.png';
import EmployeeService from '../../../../services/EmployeeService';


const DetailsPage = (props) => {
    const { setViewPage, selectedRow, onReInvite, onEditDetails } = props;
    const [details, setDetails] = useState({});
    const [showUpdateStatus, setShowUpdateStatus] = useState(false);

    const employeDetails = () => {
        EmployeeService.getEmployeById(selectedRow.id).then((res)=>{
            setDetails(res);
        });
    }
    useEffect(()=>{
        employeDetails();
    },[]);
    const onDeactive = (resta) => {
        EmployeeService.changeEmployeStatus(selectedRow.id, resta.id).then((resp)=>{
          if(resp) {
            employeDetails();
            message.success("Successfully updated");
          }
        });
      };
    const showWindow = () => {
        setShowUpdateStatus(true);
    };
    return <div >
        <PageHeader
            title={<div><img src={back} alt="" onClick={()=> setViewPage('all')}/> Employee Details</div>}
            extra={[
                <Button type="text" danger onClick={()=> onReInvite(selectedRow)}>Re-invite Employee</Button>,
                <Button type="" danger onClick={()=> showWindow(selectedRow)}>Deactivate Employee</Button>,
                <Button type="primary" onClick={()=> onEditDetails(selectedRow)}>Edit Details</Button>
            ]} />
        <div className=" " style={{ padding: "16px 24px"}}>
            <div className='details_head'>
                <div className="">
                    <img src={selectedRow?.photo_url || DP} alt="" height="65px" style={{}} />
                    {selectedRow?.name}
                </div>
                <div className="designation">{selectedRow?.restaurant_roles[0]?.employee_type?.name}</div>
            </div>
            <div className="details_content">
                <div className="left_details">
                    <div className="card_item">
                        <div className='item_logo'><img src={mail} alt=""/></div>
                        <div className="item_content">
                            <label>Email</label>
                            <div>{selectedRow.email}</div>
                        </div>
                    </div>
                    <div className="card_item">
                        <div className='item_logo'><img src={phone} alt=""/></div>
                        <div className="item_content">
                            <label>Phone Number</label>
                            <div>{selectedRow.phone_number}</div>
                        </div>
                    </div>
                    <div className="card_item">
                        <div className='item_logo'><img src={empCard} alt=""/></div>
                        <div className="item_content">
                            <label>Emplye code</label>
                            <div>{selectedRow?.restaurant_roles[0]?.employee_code}</div>
                        </div>
                    </div>
                    <div className="card_item">
                        <div className='item_logo'><img src={calender} alt=""/></div>
                        <div className="item_content">
                            <label>Profile Created Date</label>
                            <div>{moment(selectedRow.created_at).format('DD/MM/YYYY')}</div>
                        </div>
                    </div>
                </div>
                <div className="right_details">
                    <ul>
                        <div className='location_heading'>
                            <div className="pin_img"><img src={pin} alt=""/></div>
                            <div className='loc_title'>Active Location</div>
                        </div>
                        {
                            details?.restaurants?.map((loc)=>{
                                return <li>{loc.name}</li>
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
        <Modal visible={showUpdateStatus} footer={null} onCancel={()=>setShowUpdateStatus(false)} className="memberset_edit">
            <div className="confirm_wrap">
                <div className="details_head">
                    <div className="img_sec">
                    <img src={selectedRow.photo_url || DP} alt="user" height="50px" />
                    </div>
                    <div className="user_info">
                    <div className="name">{selectedRow.name}</div>
                    <div className="email">{selectedRow.email}</div>
                    </div>
                </div>
                <div className='resta_listing'>
                        <div className='status_title'>Select Restaurant </div>
                        {
                            details?.restaurants?.map((loc, key)=>{
                                const resDetails = details?.restaurant_roles.filter((it) => it.restaurant_id === loc.id);
                                return <div className="rest_item">
                                    <Checkbox onChange={()=> onDeactive(loc)} checked={resDetails[0]?.is_active}>{loc.name}</Checkbox>
                                </div>
                            })
                        }
                </div>
            </div>
        </Modal>
    </div>
};
export default DetailsPage;